(ns manage.adset-preview-panel.view.context-field
  (:require [common.util :refer [string-number?]]
            [common.widgets.editable-label :as editable-label]
            [uix.core :refer [$]]))

(defmulti context-field :type)

(defmethod context-field
  "bool"
  [{:keys [value values on-change]}]
  [:f> editable-label/dropdown
   {:on-change on-change
    :value value
    :options values}])

(defmethod context-field
  "enum"
  [{:keys [value values on-change selected-component stack-direction]
    :or {selected-component :chip stack-direction "row"}}]
  [:f> editable-label/dropdown
   {:on-change on-change
    :selected-component selected-component
    :value value
    :stack-direction stack-direction
    :options values}])

(defmethod context-field
  "option"
  [param]
  [context-field (assoc param :type "enum")])

(defmethod context-field
  "integer"
  [{:keys [value on-change minimum maximum]}]
  (letfn [(->integer [v]
            (if (and (some? v) (string-number? v)) (int v) v))]
    ($ editable-label/input
       {:on-change (comp on-change ->integer)
        :value value
        :inputProps #js {:type "number"
                         :min minimum
                         :max maximum}})))

(defmethod context-field
  "timestamp"
  [{:keys [value on-change]}]
  ($ editable-label/datepicker
     {:value value
      :on-change on-change}))

(defmethod context-field
  "set:option"
  [{:keys [value values on-change]}]
  [:f> editable-label/dropdown
   {:on-change on-change
    :value value
    :multi? true
    :options values}])

(defmethod context-field
  :default
  [{:keys [value on-change disabled?]}]
  ($ editable-label/input
     {:value value
      :disabled? disabled?
      :on-change on-change}))
